import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-user-header',
  templateUrl: './user-header.component.html',
  styleUrls: ['./user-header.component.css']
})
export class UserHeaderComponent implements OnInit {

  constructor(
    private authService: AuthService, 
  ) { }
  businessID = this.authService.getTokenData().businessID;
  userID = this.authService.getTokenData().id;

  ngOnInit(): void {
 
  }

  logout(){
    this.authService.doLogOut();
  }

}
